import React, { useState } from 'react';

export const BetsExpandCollapseContext = React.createContext(null);

export function useBetsExpandCollapseContext() {

    const [context,setContext] = useState({
        betsCollapsedById:[],
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        setBetsCollapsedById(betsCollapsedById=[]){
           this.update({betsCollapsedById})
        },
        toggleBetCollapsedById: toggleBetCollapsedById,
        toggleAllBetsCollapsed: toggleAllBetsCollapsed,
        resetBetsCollapsed: resetBetsCollapsed,
        isAllBetsCollapsed: isAllBetsCollapsed,
        isAllBetsUncollapsed: isAllBetsUncollapsed,
        isBetCollapsed: isBetCollapsed,
        isBetNotCollapsed: isBetNotCollapsed,
        isBetUndefinedCollapsed: isBetUndefinedCollapsed
    });

    function toggleBetCollapsedById(id,collapsed=null){
        if(collapsed!==null){
            context.betsCollapsedById[id]=collapsed;
        }else{
            if(context.betsCollapsedById[id]===undefined || context.betsCollapsedById[id]===true){
                context.betsCollapsedById[id]=false;
            }
            else{
                context.betsCollapsedById[id]=true;
            }
        }
        context.setBetsCollapsedById( context.betsCollapsedById);
    }

    function toggleAllBetsCollapsed(){
        if(isAllBetsCollapsed() === true || isAllBetsUncollapsed() === true ){
            Object.keys(context.betsCollapsedById).forEach(function(id){toggleBetCollapsedById(id)})
        }
        else{
            Object.keys(context.betsCollapsedById).forEach(function(id){if(context.betsCollapsedById[id])toggleBetCollapsedById(id)})
        }
    }

    function resetBetsCollapsed(){
        context.betsCollapsedById = [];
    }

    function isAllBetsCollapsed(){
        //console.log(context.betsCollapsedById);
        return Object.values(context.betsCollapsedById).filter(function(b){return b===false}).length === 0
    }

    function isAllBetsUncollapsed(){
        return Object.values(context.betsCollapsedById).filter(function(b){return b===true}).length === 0
    }

    function isBetCollapsed(id){
        return context.betsCollapsedById[id] === true;
    }

    function isBetNotCollapsed(id){
        return context.betsCollapsedById[id] === false;
    }

    function isBetUndefinedCollapsed(id){
        return context.betsCollapsedById[id] === undefined;
    }

    return [context, setContext];
}